export default __webpack_public_path__ + "static/media/Send.01e88bbe.svg";